import data from "../data/database.json";


const sqlQuiz = data.sql;
const mysqlQuiz = data.mysql;
const oracleQuiz = data.oracle;
const mongodbQuiz = data.mongodb;
const redisQuiz = data.redis;


export {sqlQuiz, mysqlQuiz, oracleQuiz, mongodbQuiz, redisQuiz};
